import React from 'react';
import CargomaticModal from 'components/v2/modal';
import XIcon from 'components/v2/icons/XIcon';
import { ConfirmationModal } from './OfferPlannerModalContainer';

const OfferPlannerModal = (props) => {
  const useRenderer =
    props.body.modalHeaderControlled &&
    typeof props.body.modalHeaderControlled === 'function';
  const renderBody = () => {
    return (
      <>
        <div className="flex justify-start px-4">
          {!props.body.modalHeaderControlled &&
            props.body.modalHeaders.map((mHeader) => {
              return <h1 className="text-sm">{mHeader}</h1>;
            })}
          {useRenderer &&
            props.body.modalHeaderControlled(props.items, props.type)}
        </div>
        <div className="px-4 mx-auto overflow-auto max-h-96">
          <button
            onClick={() => props.onClose()}
            className="absolute top-4 right-4"
          >
            <XIcon />
          </button>
          <table className=" mx-auto mt-2 mb-12">
            <thead>
              <tr className="bg-gray-100 text-gray-500 uppercase text-xs">
                {props.body.tableHeaders.map((tHeader) => {
                  return (
                    <th className="py-1 pr-10 text-center whitespace-nowrap">
                      {tHeader}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {props.body.tableRows(
                props.items,
                props.setItems,
                props.offerPlanners,
                props.offerPlannersIndex,
                props.setConfirmationModal,
                props.type
              )}
            </tbody>
          </table>
          {props.confirmationModal &&
            props.confirmationModal.action &&
            ConfirmationModal(
              props.confirmationModal,
              () => props.setConfirmationModal({}),
              props.refreshData,
              props.setItems,
              props.type,
              props.setLoading
            )}
        </div></>
    );
  };

  return (
    <CargomaticModal
      showHeader={false}
      show={props.show}
      onHide={props.onClose}
      body={renderBody()}
      dialogClassName={props.body.widthClass}
    />
  );
};

export default OfferPlannerModal;
